import { ReactNode, useRef } from "react";

import { KindeAuthProvider, useKindeAuthHook } from "./kinde-auth-provider";
import { getContextSession } from "./shared";

type LoginOptions = {
  state?: Record<string, string>;
};

export type UseAuthType = {
  isAuthenticated: boolean;
  isLoading: boolean;
  getToken: () => Promise<string>;
  session: string;
  login: (options: LoginOptions) => Promise<void>;
  logout: () => Promise<void>;
};

export function useAuth(): UseAuthType {
  const session = useRef(getContextSession());

  return {
    ...useKindeAuthHook(),
    session: session.current,
  };
}

function AuthProvider({ children }: { children: ReactNode }) {
  return <KindeAuthProvider>{children}</KindeAuthProvider>;
}

export default AuthProvider;
